<div class="post-page">
  <div class="post-main">
    <h1 class="page-title">{{ 'post.title' | t }}</h1>

    @if (!isLoggedIn) {
      <section class="card centered">
        <mat-icon class="big-icon">campaign</mat-icon>
        <p>{{ 'post.loginPrompt' | t }}</p>
        <button type="button" class="btn-pill btn-pill-accent" (click)="openLogin()">{{ 'header.loginOrSignup' | t }}</button>
      </section>
    } @else {

      <ol class="stepper">
        <li [class.active]="step === 'link'" [class.done]="step !== 'link'"><span>1</span>{{ (isInStore ? 'post.store.step' : 'post.stepLink') | t }}</li>
        <li [class.active]="step === 'details'" [class.done]="step === 'done'"><span>2</span>{{ 'post.stepDetails' | t }}</li>
        <li [class.active]="step === 'done'"><span>3</span>{{ 'post.stepReview' | t }}</li>
      </ol>

      @switch (step) {

        <!-- ===== Étape 1 : lien ===== -->
        @case ('link') {
          <div class="segmented mode-switch" role="tablist">
            <button type="button" role="tab" [class.active]="!isInStore" [attr.aria-selected]="!isInStore" (click)="setMode('online')">
              <mat-icon>link</mat-icon>{{ 'post.store.modeOnline' | t }}
            </button>
            <button type="button" role="tab" [class.active]="isInStore" [attr.aria-selected]="isInStore" (click)="setMode('inStore')">
              <mat-icon>storefront</mat-icon>{{ 'post.store.modeInStore' | t }}
            </button>
          </div>

          @if (isInStore) {
            <!-- ===== Étape 1 bis : photos d'une offre en magasin ===== -->
            <section class="card in-store">
              <p class="muted">{{ 'post.store.subtitle' | t }}</p>

              <div class="photo-buttons">
                <label class="btn-pill btn-pill-accent file-button" [class.disabled]="scanning || photos.length >= maxPhotos">
                  <mat-icon>photo_camera</mat-icon>{{ 'post.store.takePhoto' | t }}
                  <input type="file" accept="image/*" capture="environment" [disabled]="scanning || photos.length >= maxPhotos"
                    (change)="onPhotosSelected($event)" />
                </label>
                <label class="btn-pill btn-pill-outline file-button" [class.disabled]="scanning || photos.length >= maxPhotos">
                  <mat-icon>photo_library</mat-icon>{{ 'post.store.choosePhotos' | t }}
                  <input type="file" accept="image/*" multiple [disabled]="scanning || photos.length >= maxPhotos"
                    (change)="onPhotosSelected($event)" />
                </label>
              </div>
              <small class="muted">{{ 'post.store.photoHint' | t: { max: maxPhotos } }}</small>

              @if (photos.length) {
                <div class="photo-list">
                  @for (photo of photos; track photo.preview) {
                    <div class="photo-thumb" [class.busy]="photo.busy">
                      <img [src]="photo.preview" alt="" />
                      @if (photo.busy) {
                        <span class="spinner" role="status" [attr.aria-label]="'post.pictureSaving' | t"></span>
                      } @else {
                        <button type="button" class="picture-remove" [disabled]="scanning" (click)="removePhoto(photo)"
                          [attr.aria-label]="'post.store.removePhoto' | t" [title]="'post.store.removePhoto' | t">
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                    </div>
                  }
                </div>
              }
              @if (photoError) { <small class="error-text">{{photoError}}</small> }

              @if (scanning) {
                <div class="scan-progress" role="status">
                  <span class="spinner"></span>
                  <span>{{ (scanStep === 'barcode' ? 'post.store.scanBarcode' : 'post.store.scanText') | t: { percent: scanProgress } }}</span>
                </div>
              }

              <div class="actions">
                <button type="button" class="btn-text" [disabled]="scanning || photosBusy || !readyPhotos.length" (click)="skipAnalysis()">
                  {{ 'post.store.fillManually' | t }}
                </button>
                <button type="button" class="btn-pill btn-pill-accent" [disabled]="scanning || photosBusy || !readyPhotos.length" (click)="analyzePhotos()">
                  <mat-icon>auto_awesome</mat-icon>{{ (scanning ? 'post.analyzing' : 'post.store.analyze') | t }}
                </button>
              </div>
              <p class="share-tip muted"><mat-icon>lock</mat-icon><span>{{ 'post.store.privacyTip' | t }}</span></p>
            </section>
          } @else {
          <section class="card">
            <p class="muted">{{ 'post.subtitle' | t }}</p>
            <form class="url-form" (ngSubmit)="analyze()">
              <label class="field-label" for="post-url">{{ 'post.urlLabel' | t }}</label>
              <div class="url-row">
                <input id="post-url" name="url" type="url" class="text-input" [(ngModel)]="url"
                  [placeholder]="'post.urlPlaceholder' | t" autocomplete="off" inputmode="url" required />
                @if (canPaste) {
                  <button type="button" class="btn-pill btn-pill-outline paste-btn" [disabled]="analyzing" (click)="pasteLink()">
                    <mat-icon>content_paste</mat-icon>{{ 'post.paste' | t }}
                  </button>
                }
                <button type="submit" class="btn-pill btn-pill-accent" [disabled]="analyzing">
                  {{ (analyzing ? 'post.analyzing' : 'post.analyze') | t }}
                </button>
              </div>
            </form>
            @if (error) { <p class="error-text">{{error}}</p> }
            <p class="share-tip muted"><mat-icon>ios_share</mat-icon><span>{{ 'post.shareTip' | t }}</span></p>
          </section>
          }
        }

        <!-- ===== Étape 2 : détails ===== -->
        @case ('details') {
          @if (preview) {
            <section class="card merchant" [class.partner]="preview.partner">
              @if (preview.merchantLogo) {
                <img class="merchant-logo" [src]="preview.merchantLogo" [appImgFallback]="preview.merchantLogoFallback" [alt]="preview.merchant?.name || preview.host" />
              } @else {
                <mat-icon class="merchant-icon">storefront</mat-icon>
              }
              <div class="merchant-text">
                <strong>{{ preview.merchant?.name || ('post.unknownMerchant' | t: { host: preview.host }) }}</strong>
                @if (preview.partner) {
                  <span class="accent"><mat-icon>handshake</mat-icon>{{ 'post.partner' | t }} · {{ 'post.partnerHint' | t: { points: preview.estimatedPoints } }}</span>
                } @else {
                  <span class="muted">{{ 'post.notPartner' | t }} · {{ 'post.notPartnerHint' | t: { points: preview.estimatedPoints } }}</span>
                }
                <small class="muted url">{{preview.url}}</small>
              </div>
              <button type="button" class="btn-text" (click)="changeUrl()">{{ 'post.changeUrl' | t }}</button>
            </section>

            @if (!preview.partner && preview.partnerPoints > preview.estimatedPoints) {
              <section class="card duplicate not-partner">
                <mat-icon>info</mat-icon>
                <span>{{ 'post.notPartnerInfo' | t: { points: preview.estimatedPoints, partnerPoints: preview.partnerPoints } }}</span>
              </section>
            }

            @if (preview.duplicate) {
              <section class="card duplicate">
                <mat-icon>content_copy</mat-icon>
                <span>{{ 'post.duplicate' | t }}</span>
                @if (preview.duplicate.productId) {
                  <a class="btn-text" [routerLink]="['/product', preview.duplicate.productId]">{{ 'post.duplicateLink' | t }}</a>
                }
              </section>
            }

            @if (preview.availability === 'outOfStock') {
              <section class="card duplicate">
                <mat-icon>remove_shopping_cart</mat-icon>
                <span>{{ 'post.outOfStock' | t }}</span>
              </section>
            }

            <p class="autofill-note" [class.warning]="!preview.scraped">
              <mat-icon>{{ preview.scraped ? 'auto_awesome' : 'edit_note' }}</mat-icon>
              <span>{{ (preview.scraped ? 'post.autoFilled' : 'post.notAutoFilled') | t }}</span>
            </p>
          }

          @if (isInStore) {
            <section class="card merchant store-card" [class.partner]="storePreview?.partner">
              @if (storePreview?.merchantLogo) {
                <img class="merchant-logo" [src]="storePreview.merchantLogo" [appImgFallback]="storePreview.merchantLogoFallback" [alt]="storePreview.merchant?.name || store.name" />
              } @else {
                <mat-icon class="merchant-icon">storefront</mat-icon>
              }
              <div class="merchant-text">
                <strong>{{ 'post.store.inStoreAt' | t: { store: storePreview?.merchant?.name || store.name || '…' } }}</strong>
                @if (storePreview) {
                  @if (storePreview.partner) {
                    <span class="accent"><mat-icon>handshake</mat-icon>{{ 'post.partner' | t }} · {{ 'post.partnerHint' | t: { points: storePreview.estimatedPoints } }}</span>
                  } @else {
                    <span class="muted">{{ 'post.notPartnerHint' | t: { points: storePreview.estimatedPoints } }}</span>
                  }
                }
                <small class="muted">{{ 'post.store.photoCount' | t: { count: readyPhotos.length } }}</small>
              </div>
              <button type="button" class="btn-text" (click)="changePhotos()">{{ 'post.store.changePhotos' | t }}</button>
            </section>

            <p class="autofill-note" [class.warning]="!detectedCount">
              <mat-icon>{{ detectedCount ? 'auto_awesome' : 'edit_note' }}</mat-icon>
              <span>{{ (detectedCount ? 'post.store.autoFilled' : 'post.store.notAutoFilled') | t: { count: detectedCount } }}</span>
            </p>
          }

          <form class="card details" (ngSubmit)="submit()">
            @if (isInStore) {
              <div class="row">
                <div class="field">
                  <label class="field-label" for="post-store">
                    {{ 'post.store.name' | t }} *
                    @if (detected.storeName) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
                  </label>
                  <input id="post-store" name="storeName" class="text-input" list="post-store-list" [(ngModel)]="store.name" maxlength="80"
                    [placeholder]="'post.store.namePlaceholder' | t" (change)="loadStorePreview()" (blur)="loadStorePreview()" required />
                  <datalist id="post-store-list">
                    @for (name of knownStores; track name) { <option [value]="name"></option> }
                  </datalist>
                </div>
                <div class="field">
                  <label class="field-label" for="post-city">{{ 'post.store.city' | t }}</label>
                  <input id="post-city" name="storeCity" class="text-input" [(ngModel)]="store.city" maxlength="80"
                    [placeholder]="'post.store.cityPlaceholder' | t" autocomplete="address-level2" />
                </div>
              </div>

              <div class="field">
                <span class="field-label">{{ 'post.store.location' | t }}</span>
                <div class="location-row">
                  @if (hasLocation) {
                    <span class="location-ok"><mat-icon>place</mat-icon>{{ 'post.store.locationSaved' | t: { accuracy: store.accuracy } }}</span>
                    <button type="button" class="btn-text" (click)="clearLocation()">{{ 'post.store.locationRemove' | t }}</button>
                  } @else {
                    <button type="button" class="btn-pill btn-pill-outline" [disabled]="locating" (click)="locate()">
                      <mat-icon>my_location</mat-icon>{{ (locating ? 'post.store.locating' : 'post.store.useLocation') | t }}
                    </button>
                  }
                </div>
                <small class="muted">{{ 'post.store.locationHint' | t }}</small>
                @if (locationError) { <small class="error-text">{{locationError}}</small> }
              </div>
            } @else {
            <div class="field">
              <span class="field-label">{{ 'post.type' | t }}</span>
              <div class="segmented">
                <button type="button" [class.active]="form.dealType === 'goodPlan'" (click)="form.dealType = 'goodPlan'">
                  <mat-icon>local_offer</mat-icon>{{ 'post.typeGoodPlan' | t }}
                </button>
                <button type="button" [class.active]="form.dealType === 'promotionCode'" (click)="form.dealType = 'promotionCode'">
                  <mat-icon>content_cut</mat-icon>{{ 'post.typePromoCode' | t }}
                </button>
              </div>
            </div>
            }

            <div class="field">
              <label class="field-label" for="post-title">
                {{ 'post.titleLabel' | t }} *
                @if (detected.title && isInStore) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
              </label>
              <input id="post-title" name="title" class="text-input" [(ngModel)]="form.title" maxlength="200"
                [placeholder]="'post.titlePlaceholder' | t" required #titleInput="ngModel" />
              <small class="muted counter">{{form.title.length}}/200</small>
              @if (titleInput.touched && titleInvalid) { <small class="error-text">{{ 'post.titleLength' | t }}</small> }
            </div>

            @if (form.dealType === 'promotionCode') {
              <div class="field">
                <label class="field-label" for="post-code">{{ 'post.promoCode' | t }} *</label>
                <input id="post-code" name="promotionCode" class="text-input code-input" [(ngModel)]="form.promotionCode" maxlength="60" required />
              </div>
            }

            <div class="row">
              <div class="field">
                <label class="field-label" for="post-price">
                  {{ 'post.price' | t }}
                  @if (detected.priceDiscount && isInStore) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
                </label>
                <input id="post-price" name="priceDiscount" type="number" min="0" step="0.01" class="text-input" [(ngModel)]="form.priceDiscount" />
              </div>
              <div class="field">
                <label class="field-label" for="post-old-price">
                  {{ 'post.oldPrice' | t }}
                  @if (detected.price && isInStore) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
                </label>
                <input id="post-old-price" name="price" type="number" min="0" step="0.01" class="text-input" [(ngModel)]="form.price" />
              </div>
              <div class="field discount-field">
                @if (discountPercent !== null) {
                  <span class="discount-badge">{{ 'post.discount' | t: { percent: discountPercent } }}</span>
                }
              </div>
            </div>

            <div class="row">
              @if (!isInStore) {
                <div class="field">
                  <label class="field-label" for="post-delivery">{{ 'post.delivery' | t }}</label>
                  <input id="post-delivery" name="deliveryPrice" class="text-input" [(ngModel)]="form.deliveryPrice" maxlength="40"
                    [placeholder]="'post.deliveryPlaceholder' | t" />
                </div>
              }
              <div class="field">
                <label class="field-label" for="post-category">
                  {{ 'post.category' | t }}
                  @if (detected.category && isInStore) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
                </label>
                <select id="post-category" name="category" class="text-input" [(ngModel)]="form.category">
                  <option value="">{{ 'post.chooseCategory' | t }}</option>
                  @for (category of categories; track category.value) {
                    <option [value]="category.value">{{ category.labelKey | t }}</option>
                  }
                </select>
              </div>
            </div>

            <div class="field">
              <span class="field-label">{{ 'post.picture' | t }}</span>
              <div class="picture-box" [class.drag-over]="dragOver"
                (dragover)="onDragOver($event)" (dragleave)="dragOver = false" (drop)="onDrop($event)">
                <div class="picture-current">
                  @if (pictureBusy) {
                    <span class="spinner" role="status" [attr.aria-label]="'post.pictureSaving' | t"></span>
                  } @else if (form.pictureUrl && !pictureBroken) {
                    <img [src]="form.pictureUrl" alt="" (error)="pictureBroken = true" />
                    <button type="button" class="picture-remove" (click)="removePicture()"
                      [attr.aria-label]="'post.pictureRemove' | t" [title]="'post.pictureRemove' | t">
                      <mat-icon>close</mat-icon>
                    </button>
                  } @else {
                    <mat-icon class="picture-empty">add_photo_alternate</mat-icon>
                    <small class="muted">{{ 'post.pictureNone' | t }}</small>
                  }
                </div>

                <div class="picture-actions">
                  @if (pictureCandidates.length) {
                    <span class="muted small">{{ (isInStore ? 'post.store.pictureChoose' : 'post.pictureOthers') | t }}</span>
                    <div class="picture-candidates">
                      @for (candidate of pictureCandidates; track candidate) {
                        <button type="button" class="candidate" [class.active]="candidate === selectedCandidate"
                          [disabled]="pictureBusy" (click)="selectCandidate(candidate)">
                          <img [src]="candidate" alt="" referrerpolicy="no-referrer" loading="lazy" (error)="hideCandidate(candidate)" />
                        </button>
                      }
                    </div>
                  }

                  <div class="picture-buttons">
                    <label class="btn-pill btn-pill-outline file-button" [class.disabled]="pictureBusy">
                      <mat-icon>upload</mat-icon>{{ 'post.pictureUpload' | t }}
                      <input type="file" [accept]="acceptedImageTypes" [disabled]="pictureBusy" (change)="onFileSelected($event)" />
                    </label>
                    <button type="button" class="btn-text" (click)="showPictureLink = !showPictureLink">
                      <mat-icon>link</mat-icon>{{ 'post.pictureFromLink' | t }}
                    </button>
                  </div>

                  @if (showPictureLink) {
                    <div class="url-row">
                      <input name="pictureLink" type="url" class="text-input" [(ngModel)]="pictureLink" autocomplete="off"
                        [placeholder]="'post.pictureLinkPlaceholder' | t" (keydown.enter)="$event.preventDefault(); importPictureLink()" />
                      <button type="button" class="btn-pill btn-pill-accent" [disabled]="pictureBusy || !pictureLink.trim()" (click)="importPictureLink()">
                        {{ 'post.pictureUseLink' | t }}
                      </button>
                    </div>
                  }

                  <small class="muted">{{ 'post.pictureHint' | t }}</small>
                </div>
              </div>
              @if (pictureError) { <small class="error-text">{{pictureError}}</small> }
              @if (pictureBroken) { <small class="error-text">{{ 'post.pictureBroken' | t }}</small> }
            </div>

            <div class="row">
              <div class="field">
                <label class="field-label" for="post-start">
                  {{ 'post.startDate' | t }}
                  @if (detected.startDate && isInStore) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
                </label>
                <input id="post-start" name="startDate" type="date" class="text-input" [(ngModel)]="form.startDate" />
              </div>
              <div class="field">
                <label class="field-label" for="post-end">
                  {{ 'post.endDate' | t }}
                  @if (detected.expirationDate && isInStore) { <span class="detected-badge"><mat-icon>auto_awesome</mat-icon>{{ 'post.store.detected' | t }}</span> }
                </label>
                <input id="post-end" name="expirationDate" type="date" class="text-input" [(ngModel)]="form.expirationDate" />
              </div>
            </div>
            @if (isInStore && !form.expirationDate && storePreview) {
              <small class="muted end-hint">{{ 'post.store.defaultDuration' | t: { days: storePreview.inStoreDealDays } }}</small>
            }

            <div class="field">
              <label class="field-label" for="post-description">{{ 'post.description' | t }}</label>
              <textarea id="post-description" name="description" class="text-input" rows="6" maxlength="5000" [(ngModel)]="form.description"
                [placeholder]="'post.descriptionPlaceholder' | t"></textarea>
            </div>

            <label class="checkbox-line">
              <input type="checkbox" name="certified" [(ngModel)]="certified" />
              <span>{{ 'post.certify' | t }}</span>
            </label>

            @if (error) { <p class="error-text">{{error}}</p> }

            <div class="actions">
              <button type="button" class="btn-pill btn-pill-outline" (click)="isInStore ? changePhotos() : changeUrl()">{{ 'common.back' | t }}</button>
              <button type="submit" class="btn-pill btn-pill-accent" [disabled]="!canSubmit">
                <mat-icon>send</mat-icon>{{ (submitting ? 'post.submitting' : 'post.submit') | t }}
              </button>
            </div>
          </form>
        }

        <!-- ===== Étape 3 : envoyé ===== -->
        @case ('done') {
          <section class="card centered done">
            <mat-icon class="big-icon">celebration</mat-icon>
            <h2>{{ 'post.successTitle' | t }}</h2>
            <p>{{ 'post.successText' | t: { points: estimatedPoints } }}</p>
            <div class="actions center">
              <a class="btn-pill btn-pill-accent" routerLink="/compte/contributions">{{ 'post.seeContributions' | t }}</a>
              <button type="button" class="btn-pill btn-pill-outline" (click)="postAnother()">{{ 'post.postAnother' | t }}</button>
            </div>
          </section>
        }
      }
    }
  </div>

  <!-- Colonne d'aide : barème de points et conseils -->
  <aside class="post-aside">
    <section class="card">
      <h2 class="card-title"><mat-icon>stars</mat-icon>{{ 'post.earnTitle' | t }}</h2>
      <ul class="earn-list">
        <li><mat-icon>task_alt</mat-icon>{{ 'post.earnApproved' | t }}</li>
        <li><mat-icon>handshake</mat-icon>{{ 'post.earnPartner' | t }}</li>
        <li><mat-icon>local_fire_department</mat-icon>{{ 'post.earnHot' | t }}</li>
        <li><mat-icon>redeem</mat-icon>{{ 'post.earnRewards' | t }}</li>
      </ul>
      <a class="btn-text" routerLink="/compte/club">{{ 'post.learnMore' | t }}</a>
    </section>
    <section class="card">
      <h2 class="card-title"><mat-icon>tips_and_updates</mat-icon>{{ 'post.tips' | t }}</h2>
      <ul class="earn-list">
        <li><mat-icon>check</mat-icon>{{ 'post.tip1' | t }}</li>
        <li><mat-icon>check</mat-icon>{{ 'post.tip2' | t }}</li>
        <li><mat-icon>check</mat-icon>{{ 'post.tip3' | t }}</li>
      </ul>
    </section>
  </aside>
</div>
